// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import App from './App'
import Vue from 'vue'
import http from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import store from './vuex/store'
import router from './router'
import VueTheMask from 'vue-the-mask'
import vuelidate from 'vuelidate'
import interceptor from './router/interceptor'
import Snotify from 'vue-snotify'
import filters from './filters/index'
import directives from './directives/index'
import { Loading, Select } from 'element-ui'
import Croppa from 'vue-croppa'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
OfflinePluginRuntime.install()

Vue.use(Snotify, {
  toast: {
    bodyMaxLength: 200,
    titleMaxLength: 50,
    timeout: 5000,
    position: 'rightTop'
  }
})
Vue.use(vuelidate)
Vue.use(VueTheMask)
Vue.use(http)
Vue.use(BootstrapVue)
Vue.use(Croppa)
Vue.component(Select.name, Select)
Vue.use(Loading.directive)
// Vue.http.options.credentials = true
Vue.http.interceptors.push(interceptor)
Vue.prototype.$loading = Loading.service

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  filters,
  directives,
  template: '<App/>',
  components: {
    App: () => import(/* webpackChunkName: "progetaApp" */ './App.vue')
  }
})



// WEBPACK FOOTER //
// ./src/main.js